import React from 'react'
import Navbar from '../components/Home/Navbar/Navbar'
import Allblogs from '../components/Blogs/Allblogs'
import Footer from '../components/Home/Footer/Footer'


const Blogpage = () => {
    return (
        <div>
        <Navbar/>
        <main>
        <Allblogs/>
        </main>
        <Footer/>
 


        </div>
    )
}

export default Blogpage
